<ng-container
  *ngIf="{
    items: items$ | async,
    config: corrouselConfig$ | async,
    title: title$ | async,
    showCarousel: showCarousel$ | async,
  } as content"
>
  @if (content.showCarousel && content.items?.length) {
    <div class="js-container-product-carousel container-product-carousel w-100">
      <div class="col-12">
        <h2 class="main-title" *ngIf="content.title">{{ content.title }}</h2>
      </div>

      <p-carousel
        role="region"
        [attr.aria-label]="'productCarousel.carouselLabel' | cxTranslate: { title: content.title }"
        [value]="content.items || []"
        [numVisible]="qtyItemsVisible()"
        [numScroll]="qtyItemsVisible()"
        [circular]="content.config?.circular || true"
        [autoplayInterval]="content.config?.autoplayInterval || 0"
        [classList]="'custom-carousel product-carousel'"
        [responsiveOptions]="content.config?.responsiveOptions"
        [showNavigators]="content.config?.showNavigators !== undefined ? content.config?.showNavigators : true"
        [showIndicators]="content.config?.showIndicators !== undefined ? content.config?.showIndicators : true"
      >
        <ng-template pTemplate="item" let-item>
          <ng-container *ngIf="item | async as item">
            <div class="custom-item {{ qtyItemsVisible() }}">
              <cx-product-carousel-item [item]="convertItemToProduct(item)"></cx-product-carousel-item>
            </div>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="previousicon" let-item>
          <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
        </ng-template>

        <ng-template pTemplate="nexticon" let-item>
          <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
        </ng-template>
      </p-carousel>
    </div>
  }
</ng-container>
